import { motion } from "framer-motion";
import css from "./Page.module.scss";
import { useSidebar } from "src/utils/SidebarProvider";

const animations = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    //   exit: { opacity: 0, y: -50 },
};

const Page = ({ children }) => {

    const { open } = useSidebar()

    return (
        <motion.div
            variants={animations}
            initial="initial"
            animate="animate"
            className={`${css["page"]} ${open ? css["open"] : undefined}`}
            // exit="exit"
            transition={{ ease: "easeInOut", duration: 0.2 }}
        >
            {children}
        </motion.div>
    );
};

export default Page;
